import React from 'react';
import Tag from '../../components/tag/Tag';
import { useTranslations } from '../../localization/useTranslations';
import Tabs from '../../components/tabs/Tabs';

interface AuthorHeaderProps {
  selectedRole: string;
}

const AuthorHeader: React.FC<AuthorHeaderProps> = ({ selectedRole }) => {
  const labels = window.AuthorPageLabels; // Labels specific to the Author page
  const translations = useTranslations(); // Translations for localization

  // Function to get the title based on the selected role
  const getTitle = () => {
    switch (selectedRole) {
      case 'all':
        return translations?.authorAndTopic?.authors || 'Authors';
      case 'dopisovatel':
        return labels.contributors_title;
      case 'forbes':
        return labels.forbes_authors_title;
      case 'brandvoice':
        return labels.brandvoice_title;
      case 'life':
        return labels.life_title;
      default:
        return translations?.authorAndTopic?.authors || 'Authors';
    }
  };

  // Function to get the subtitle based on the selected role
  const getSubtitle = () => {
    switch (selectedRole) {
      case 'all':
        return translations?.general?.all || 'All';
      case 'dopisovatel':
        return labels.contributors_label;
      case 'forbes':
        return labels.forbes_authors_label;
      case 'brandvoice':
        return labels.brandvoice_authors_label;
      case 'life':
        return labels.life_authors_label;
      default:
        return translations?.general?.all || 'All';
    }
  };

  const tabs = [
    {
      label: translations?.general?.all || 'All',
      link: '/all',
    },
    {
      label: labels.contributors_label,
      link: '/dopisovatel',
    },
    {
      label: labels.forbes_authors_label,
      link: '/forbes',
    },
    {
      label: labels.brandvoice_authors_label,
      link: '/brandvoice',
    },
    {
      label: labels.life_authors_label,
      link: '/life',
    },
  ];

  return (
    <div className="authors-header">
      <div className="container">
        <div className="inner">
          <div>
            <Tag text={getSubtitle()} />
            <h1 className="authors-header__title">{getTitle()}</h1>
          </div>

          <Tabs tabs={tabs} fontSize={14} useHashRouting hasBottomBorder />
        </div>
      </div>
    </div>
  );
};

export default AuthorHeader;
